import { Classificazione } from '../../../models/classificazione';

export class ClassificazioneAdapter {

  static createClassificazione(classificazione: Classificazione): Classificazione {
    let newClassificazione = new Classificazione();
    if (classificazione.id) {
      newClassificazione.id = classificazione.id;
    }

    newClassificazione.isPrincipale = classificazione.isPrincipale ? classificazione.isPrincipale : false;

    newClassificazione.materia = classificazione.materia ? JSON.parse(JSON.stringify(classificazione.materia)) : null;
    newClassificazione.oggetto = classificazione.oggetto ? JSON.parse(JSON.stringify(classificazione.oggetto)) : null;
    newClassificazione.argomento = classificazione.argomento ? JSON.parse(JSON.stringify(classificazione.argomento)) : null;

    return newClassificazione;
  }
}
